import { Button } from "@mui/material";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import { useIntl } from "react-intl";

export default function FloatingOrderButton() {
  const intl = useIntl();
  const t = (id, values) => intl.formatMessage({ id }, values);

  return (
    <Button
      variant="contained"
      disableElevation
      startIcon={<DirectionsCarIcon />}
      onClick={() => { window.location.assign("/login"); }}
      aria-label={t("floatingOrderButton.label")}
      sx={{
        position: "fixed",
        bottom: "110px",
        right: "24px",
        zIndex: 9999,
        borderRadius: "50px",
        background: "linear-gradient(135deg, #158b4a 0%, #0b7a45 100%) !important",
        color: "#ffffff !important",
        padding: "12px 24px",
        fontSize: "18px",
        fontFamily: "'RebelSansText', sans-serif",
        fontWeight: 600,
        textTransform: "none",
        boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
        transition: "transform 160ms ease, box-shadow 160ms ease",
        "& .MuiSvgIcon-root": {
          color: "#ffffff",
        },
        "&:hover": {
          background: "linear-gradient(135deg, #127d43 0%, #09663a 100%) !important",
          transform: "translateY(-3px)",
          boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
        },
      }}
    >
      {t("floatingOrderButton.label")}
    </Button>
  );
}